import { Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import type { ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';

import { useTheme } from '@woovi/hooks';

import type { PaymentLinkComment_pixQrCode$key } from './__generated__/PaymentLinkComment_pixQrCode.graphql.ts';
import type { PaymentLinkComment_charge$key } from '../active/paymentLinkActive/__generated__/PaymentLinkComment_charge.graphql.ts';


type PaymentLinkCommentProps = {
  charge: PaymentLinkComment_charge$key;
  pixQrCode: PaymentLinkComment_pixQrCode$key;
};
const PaymentLinkComment = (props: PaymentLinkCommentProps): ReactNode => {
  const theme = useTheme();
  const charge = useFragment<PaymentLinkComment_charge$key>(
    graphql`
      fragment PaymentLinkComment_charge on Charge {
        comment
      }
    `,
    props.charge,
  );

  const pixQrCode = useFragment<PaymentLinkComment_charge$key>(
    graphql`
      fragment PaymentLinkComment_pixQrCode on PixQrCode {
        comment
      }
    `,
    props.pixQrCode,
  );

  const getComment = () => {
    if (pixQrCode) {
      return pixQrCode.comment;
    }

    if (charge) {
      return charge.comment;
    }

    return null;
  };

  if (!getComment()) {
    return null;
  }

  return (
    <Stack
      sx={{
        p: '15px',
        justifyContent: 'center',
        backgroundColor: '#f4f4f4',
        borderRadius: '8px',
      }}
    >
      <Typography
        variant={'subtitle1'}
        sx={{
          fontSize: '16px',
          color: theme?.palette?.text?.secondary,
          textAlign: 'center',
        }}
      >
        {getComment()}
      </Typography>
    </Stack>
  );
};

export default PaymentLinkComment;
